import BackgroundMixTranslations from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundMixTranslations";

export default class BackgroundMixTranslateViewModel {
	id?: number = null;
    langCode?: string = '';
	name?: string = '';
	description?: string = '';
    constructor(obj?: Partial<BackgroundMixTranslateViewModel>) {
        if (obj) {
            Object.assign(this, obj);
        }
    }

    toServerModel(): BackgroundMixTranslations {
        const res = new BackgroundMixTranslations({
            Id: this.id || null, 
            Name: this.name,
            Description: this.description,
            LangCode: this.langCode,
        });
        return res;
    }
}
